export const ADDRESSES = {
    "PAIR_LOGIC": {
        "690": "0x3a31C953d7FFAfBF766d7C7Fc97C2a0c5BE137CF",
        "8453": "0x408Fc42BEDC1F9dB4bF206748390334fffecb804",
        "55378": "0xb8Be0A00687f49E00557aA687FF12d6eFc7F619c",
        "84532": "0xc2682Ee2D4a68211BB85966eA46bE4fF931bad5F"
    },
    "PROXY_ADMIN": {
        "690": "0x0FAE4EDca8bcB5088cd626C1516D33233E2F7a03",
        "8453": "0x96D0cE0cB10ba0eC7c0ab12198c371b7Ff82517e",
        "55378": "0xCcF0429Ac4944068a3926Ad5b25f030B5cb73461",
        "84532": "0x1464174b787Bbf08C4F7942419067fa3E867E3a3"
    },
    "BANK": {
        "690": "0xffa3194C0E09cD1f9CdCf5AC3e2Ba173F88087C9",
        "8453": "0x1a3Db10E8c08949Cc90821e1702B335e1B07F1a5",
        "55378": "0x6fc71BD90f75c54f4aC2678ed56579299e930ead",
        "84532": "0x30eB6a7A6E59BAa759af1a8873fC299B8707abaf"
    },
    "EXCHANGE": {
        "690": "0x28DCb3207270bcAf10A8C1A5ADD52a718874D8E0",
        "8453": "0xfF04D54D7a91D601D4a4e9B7122DE058b0E42534",
        "55378": "0x260cC99651F175F9CEd5Eb2BEE3ad3341aaE2d63",
        "84532": "0xD63D51f6f52296abe6C40bc682306765b1A97032"
    },
    "BTLY": {
        "690": "0xFF392d3f443b7B3752f9Cf0f40C3D263CB66cdCA",
        "84532": "0x9cd1d1689a08aD33DF731d2E3ff0a8487B5ba385"
    },
    "USDC": {
        "84532": "0x4fe853163A95AC410D388234B87E387352d26B08"
    },
    "FACTORY": {
        "690": "0x8325301caBf49A29E038344320f4d4e3Dedc266B",
        "8453": "0x8c7d3063579BdB0b90997e18A770eaE32E1eBb08",
        "55378": "0x6a71Dc22A0C6109279050a44B7b17A8F4837C3A0",
        "84532": "0xeeFe1fd977cD5C831828b2eD4B327d258352CCb6"
    }
};
export const FEE_TIERS = {
    "55378": [5000],
    "8453": [3000, 10000],
    "84532": [5000],
};
export const WETH9_ADDRESS = {
    "84532": "0x4200000000000000000000000000000000000006",
    "55378": "0x4200000000000000000000000000000000000006",
    "8453": "0x4200000000000000000000000000000000000006",
};
export const QUOTE_COINS = {
    "84532": [
        '0x4fe853163A95AC410D388234B87E387352d26B08',
        WETH9_ADDRESS["84532"],
    ],
    "55378": [
        WETH9_ADDRESS["55378"],
    ],
    "8453": [
        '0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913',
        '0x820c137fa70c8691f0e44dc420a5e53c168921dc',
        '0x50c5725949a6f0c72e6c4a641f24049a917db0cb',
        WETH9_ADDRESS["8453"],
    ],
    "137": [
        '0x3c499c542cEF5E3811e1192ce70d8cC03d5c3359',
        '0x2791bca1f2de4661ed88a30c99a7a9449aa84174',
        '0xc2132d05d31c914a87c6611c10748aeb04b58e8f',
    ],
};
export const RATES_ENDPOINTS = {
    "84532": 2,
    "55378": 2,
    "8453": 2,
    "137": 2,
};
export const TOKEN_BRIDGES = {
    84532: {
        "0x4fe853163A95AC410D388234B87E387352d26B08": "https://faucet.bitly.exchange"
    },
    55378: {
        "0x4200000000000000000000000000000000000006": "bridge.dustproject.org",
    },
};
// Number.MAX_SAFE_INTEGER means no limit
export const BATCH_BLOCK_SIZE = {
    "84532": 10000,
    "55378": Number.MAX_SAFE_INTEGER,
    "8453": Number.MAX_SAFE_INTEGER,
    "137": Number.MAX_SAFE_INTEGER,
};
